import CompetencyBox from './CompetencyBox.component';

export default CompetencyBox;
